import { configurationSchema } from '@certificate/configuration';

export const configuration = configurationSchema.parse({
  mode: import.meta.env.MODE,
  logLevel: import.meta.env.VITE_LOG_LEVEL,
  graphql: {
    apiUrl: import.meta.env.VITE_GRAPHQL_API_URL,
    defaultFetchPolicy: import.meta.env.VITE_GRAPHQL_DEFAULT_FETCH_POLICY,
  },
});
